const { APP_BUILDER_VERSION } = process.env;

// eslint-disable-next-line import/prefer-default-export
export const appBuilderVersion = APP_BUILDER_VERSION || '';
